import React, { useState } from "react";
import { Modal, Button, Table, Input, Select, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { Option } = Select;

const AddSuffixModal = ({
  open,
  setOpen,
  handleCancel,
  suffixInventories,
  setSuffixInventories,
}) => {
  const [loading, setLoading] = useState(false);

  const keyState =
    suffixInventories[suffixInventories.length - 1]?.key + 1 || 0;
  const [dataSource, setDataSource] = useState([
    {
      key: keyState,
      suffixCode: "",
      specialRate: "",
      suffixInfo: "",
      vendor: "",
      purchaseRate: "",
      startDate: null,
      endDate: null,
    },
  ]);

  console.log("dataSource is: ", dataSource);

  useEffect(() => {
    setDataSource([
      {
        key: keyState,
        suffixCode: "",
        specialRate: "",
        suffixInfo: "",
        vendor: "",
        purchaseRate: "",
        startDate: null,
        endDate: null,
      },
    ]);
  }, [suffixInventories]);

  // Validate data before submission
  const validateData = () => {
    for (let row of dataSource) {
      // Check for empty fields
      if (!row.suffixCode || !row.specialRate || !row.suffixInfo) {
        notification.error({
          message: "Validation Error",
          description: "Please fill in all the fields before creating.",
        });
        return false;
      }
      // Add date validation
      if (!row.startDate || !row.endDate) {
        notification.error({
          message: "Validation Error",
          description: "Please select booking period for all rows.",
        });
        return false;
      }
      // Check if specialRate is a valid number
      if (isNaN(row.specialRate) || row.specialRate <= 0) {
        notification.error({
          message: "Validation Error",
          description:
            "Price (specialRate) must be a valid number greater than 0.",
        });
        return false;
      }
    }
    return true;
  };

  const handleOk = () => {
    if (!validateData()) {
      return; // Prevent creation if validation fails
    }
    setLoading(true);
    setSuffixInventories((prev) => [...prev, ...dataSource]);
    setDataSource([
      {
        key: keyState,
        suffixCode: "",
        specialRate: "",
        suffixInfo: "",
        vendor: "",
        purchaseRate: "",
        startDate: null,
        endDate: null,
      },
    ]);
    setLoading(false);
    setOpen(false);
  };

  const handleEdit = (value, key, dataIndex) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => key === item.key);
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1, { ...item, [dataIndex]: value });
      setDataSource(newData);
    }
  };

  const handleAddRow = () => {
    const newRow = {
      key: dataSource[dataSource.length - 1].key + 1,
      suffixCode: "",
      specialRate: "",
      suffixInfo: "",
      vendor: "",
      purchaseRate: "",
      startDate: null,
      endDate: null,
    };
    setDataSource([...dataSource, newRow]);
  };

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  const options = ["Printing", "Mounting", "Magazine", "Club", "Other"];

  const columns = [
    {
      title: "Suffix Code",
      dataIndex: "suffixCode",
      key: "suffixCode",
      editable: true,
      width: 200,
      align: "center",
      render: (_, record) => (
        <Select
          value={record.suffixCode}
          onChange={(value) => handleEdit(value, record.key, "suffixCode")}
          placeholder="Suffix Code"
          style={{ width: "100%" }}
        >
          {options.map((ele) => (
            <Option key={ele} value={ele}>
              {ele}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Purchase Rate",
      dataIndex: "purchaseRate",
      key: "purchaseRate",
      editable: true,
      width: 200,
      align: "center",
      render: (_, record) => (
        <Input
          value={record.purchaseRate}
          placeholder="Add purchase rate"
          onChange={(e) =>
            handleEdit(e.target.value, record.key, "purchaseRate")
          }
        />
      ),
    },
    {
      title: "Price/Production Cost",
      dataIndex: "specialRate",
      key: "specialRate",
      editable: true,
      width: 200,
      align: "center",
      render: (_, record) => (
        <Input
          value={record.specialRate}
          placeholder="Add price"
          onChange={(e) =>
            handleEdit(e.target.value, record.key, "specialRate")
          }
        />
      ),
    },
    {
      title: "Particulars",
      dataIndex: "suffixInfo",
      key: "suffixInfo",
      editable: true,
      width: 300,
      align: "center",
      render: (_, record) => (
        <Input
          value={record.suffixInfo}
          placeholder="Add Remarks"
          onChange={(e) => handleEdit(e.target.value, record.key, "suffixInfo")}
        />
      ),
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      editable: true,
      width: 250,
      align: "center",
      render: (_, record) => (
        <Input
          value={record.vendor}
          placeholder="Add vendor"
          onChange={(e) => handleEdit(e.target.value, record.key, "vendor")}
        />
      ),
    },
    {
      title: "Booking Period",
      dataIndex: "bookingPeriod",
      key: "bookingPeriod",
      editable: true,
      width: 400,
      align: "center",
      render: (_, record) => {
        const startDate = record.startDate ? dayjs(record.startDate) : null;
        const endDate = record.endDate ? dayjs(record.endDate) : null;
        const rangeValue = startDate && endDate ? [startDate, endDate] : null;

        return (
          <DatePicker.RangePicker
            style={{ width: "100%" }}
            format="DD-MM-YYYY"
            value={rangeValue}
            onChange={(dates, dateStrings) => {
              if (dates && dates.length === 2) {
                // Update both dates at once using a new data source
                const newData = [...dataSource];
                const index = newData.findIndex(
                  (item) => item.key === record.key
                );
                if (index > -1) {
                  const item = newData[index];
                  const startDate = dayjs(dateStrings[0], "DD-MM-YYYY").format(
                    "YYYY-MM-DD"
                  );
                  const endDate = dayjs(dateStrings[1], "DD-MM-YYYY").format(
                    "YYYY-MM-DD"
                  );
                  newData.splice(index, 1, {
                    ...item,
                    startDate,
                    endDate,
                  });
                  setDataSource(newData);
                }
              } else {
                // Clear both dates at once
                const newData = [...dataSource];
                const index = newData.findIndex(
                  (item) => item.key === record.key
                );
                if (index > -1) {
                  const item = newData[index];
                  newData.splice(index, 1, {
                    ...item,
                    startDate: null,
                    endDate: null,
                  });
                  setDataSource(newData);
                }
              }
            }}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Button
          onClick={() => handleDeleteS(record)}
          disabled={dataSource.length === 1}
        >
          Delete
        </Button>
      ),
    },
  ];

  const handleDeleteS = (record) => {
    const newData = dataSource.filter((item) => item.key !== record.key);
    setDataSource(newData);
  };

  return (
    <Modal
      open={open}
      width={1200}
      title="Add Suffix"
      onOk={handleOk}
      onCancel={() => {
        handleCancel();
        setDataSource([
          {
            key: keyState,
            suffixCode: "",
            specialRate: "",
            suffixInfo: "",
            purchaseRate: "",
          },
        ]);
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            handleCancel();
            setDataSource([
              {
                key: keyState,
                suffixCode: "",
                specialRate: "",
                suffixInfo: "",
                vendor: "",
                purchaseRate: "",
              },
            ]);
          }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleOk}
        >
          Create
        </Button>,
      ]}
    >
      <Button
        type="dashed"
        onClick={handleAddRow}
        style={{ marginBottom: 16 }}
        icon={<PlusOutlined />}
      >
        Add
      </Button>
      <Table
        components={components}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        rowKey="key"
      />
    </Modal>
  );
};

export default AddSuffixModal;
